import { renderHtmlToPlainText } from './renderHtmlToPlainText'
import type { RenderMode } from './interpolateVariables'

// Rich-text editors emit a new `<p>` per Enter press, but operators expect
// signature rows (name / title / email) on consecutive lines, not blank-line-
// separated paragraphs. Collapse `<p>X</p><p>Y</p>` to `X<br>Y` first.
function normalizeSignatureHtml(html: string): string {
  return html
    .replace(/<\/p>\s*<p[^>]*>/gi, '<br>')
    .replace(/<\/?p[^>]*>/gi, '')
    .replace(/\s+$/, '')
}

export function appendSignature(
  body: string,
  signatureHtml: string,
  mode: RenderMode
): string {
  if (!signatureHtml) return body
  const normalizedSig = normalizeSignatureHtml(signatureHtml)
  if (mode === 'html') {
    // Separate the signature with one blank line (`<br><br>`), mirroring the
    // plain-text `\n\n` below. Strip any trailing `<br>` the body already has
    // so the gap is exactly one blank line, never two.
    const bodyTrimmed = body.replace(/(?:<br\s*\/?>\s*)+$/i, '')
    return `${bodyTrimmed}<br><br>${normalizedSig}`
  }
  const sigPlain = renderHtmlToPlainText(normalizedSig)
  const bodyTrimmed = body.replace(/\n+$/, '')
  return `${bodyTrimmed}\n\n${sigPlain}`
}
